import React from "react";
import "./catwhychoose.css";
import { Link } from "react-router-dom";
const features = [
  {
    icon: "/Images/why_feature_1.svg",
    title: "Quality Foods",
    description: "Praesent rutrum ligula ligula, eget viverra neque congue sed. Donec",
  },
  {
    icon: "/Images/why_feature_2.svg",
    title: "Table reservation",
    description: "Guarantee your spot, and enjoy a hassle-free dining experience with our",
  },
  {
    icon: "/Images/why_feature_3.svg",
    title: "Online Order",
    description: "Order online and savor the delicious flavors from the comfort of home",
  },
];

const AussieChoose = () => {
  return (
    <section className="why-wrapper">
      <div className="why-left">
        <p className="why-subtitle">Why Choose Us</p>
        <h2 className="cat-why-title">Best Aussie Breakfast <br/> Near Me in Mandurah</h2>
        <p className="cat-why-desc">
          Wake up to the best Aussie breakfast in Mandurah, served fresh every morning.
        </p>
         <Link to="/view-our-menu">  <button className="why-btn">SEE DETAILS →</button></Link>
      </div>

      <div className="cat-why-right">
        {features.map((item, index) => (
          <div className="cat-why-card" key={index}>
            <img src={item.icon} alt={item.title} className="why-icon" loading="lazy" />
            <h4>{item.title}</h4>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AussieChoose;
